module.exports = __webpack_public_path__ + "static/media/CIMG3409.1ce929c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/gallery/TK_bei_den_Umzuegen/CIMG3409.jpg
// module id = 418
// module chunks = 0